// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".newConversationButton__newConversationButton___3AE0L{width:236px;height:40px;font-size:16px;box-shadow:0 2px 6px 0 rgba(201,201,201,.5)}", ""]);
// Exports
exports.locals = {
	"white": "#fff",
	"primary": "#222",
	"secondary": "#717070",
	"primaryBlue": "#336dec",
	"primaryDarkerBlue": "#005bcc",
	"chatIconFrameWidth": "70px",
	"chatIconFrameHeight": "70px",
	"widgetFrameWidth": "400px",
	"widgetFrameHeight": "650px",
	"mobileScreenWidth": "550px",
	"mobileScreenHeight": "550px",
	"newConversationButton": "newConversationButton__newConversationButton___3AE0L"
};
module.exports = exports;
